import { $axios } from "./config";

const url = "/institution";

const getAllInstitutions = async () => {
    return $axios.get(`${url}/getAllInstitutions`);
};

const getAllInstitutionsMemos = async (id = "") => {
    return $axios.get(`${url}/getAllInstitutionsMemos?institutionId=${id}`);
};

const getInstitutionByInstCode = async (instCode) => {
    return $axios.get(`${url}/getInstitutionByInstCode?instCode=${instCode}`);
};

const getInstitutionById = async (instId) => {
    return $axios.get(`${url}/getInstitutionById?id=${instId}`);
};

const addOrUpdateInstitution = async (payload) => {
    return $axios.post(`${url}/addOrUpdateInstitution`, payload);
};

const deleteInstitution = async (instId) => {
    return $axios.post(`${url}/deleteInstitution?id=${instId}`);
};

const getInstitutionTypes = async (instId) => {
    return $axios.get(`${url}/getInstitutionTypes`);
};

const getInstitutionTypeById = async (id) => {
    return $axios.get(`${url}/getInstitutionTypeById?id=${id}`);
};

const addOrUpdateInstitutionType = async (payload) => {
    return $axios.post(`${url}/addOrUpdateInstitutionType`, payload);
};

const deleteInstitutionType = async (id) => {
    return $axios.post(`${url}/deleteInstitutionType?id=${id}`);
};

const getAllRegulatoryDirectives = async () => {
    return $axios.get(`/memo/getAllRegulatoryDirectives`);
};

const getAllRegulatoryDirectivesDT = async (
    searchValues = {},
    isReport = false
) => {
    return $axios.post(
        `/memo/getAllRegulatoryDirectivesDT?isReport=${isReport}`,
        searchValues
    );
};

const getAllSanctionsDT = async (searchValues = {}, isReport = false) => {
    return $axios.post(
        `/memo/getAllSanctionsDT?isReport=${isReport}`,
        searchValues
    );
};

const getAllWarningsDT = async (searchValues = {}, isReport = false) => {
    return $axios.post(
        `/memo/getAllWarningsDT?isReport=${isReport}`,
        searchValues
    );
};

const getAllTechnicalSessionsDT = async (
    searchValues = {},
    isReport = false
) => {
    return $axios.post(
        `/memo/getAllTechnicalSessionsDT?isReport=${isReport}`,
        searchValues
    );
};

const getAllMemos = async (id) => {
    return $axios.get(`/Memo/getAllInstitutionsMemos`);
};

const addOrUpdateRegulatoryDirective = async (formData) => {
    return $axios.post(`/memo/addOrUpdateRegulatoryDirective`, formData);
};

const deleteRegulatoryDirective = async (id) => {
    return $axios.post(`/memo/deleteRegulatoryDirective?id=${id}`);
};

const getAllSanctions = async (isReport = false) => {
    return $axios.get(`/memo/getAllSanctions?isReport=${isReport}`);
};

const addOrUpdateSanction = async (payload) => {
    return $axios.post(`/memo/addOrUpdateSanction`, payload);
};

const deleteSanction = async (id) => {
    return $axios.post(`/memo/deleteSanction?id=${id}`);
};

const getAllWarnings = async (id) => {
    return $axios.get(`/memo/getAllWarnings`);
};

const addOrUpdateWarning = async (payload) => {
    return $axios.post(`/memo/addOrUpdateWarning`, payload);
};

const deleteWarning = async (id) => {
    return $axios.post(`/memo/deleteWarning?id=${id}`);
};

const getAllTechnicalSessions = async (id) => {
    return $axios.get(`/memo/getAllTechnicalSessions`);
};

const addOrUpdateTechnicalSession = async (payload) => {
    return $axios.post(`/memo/addOrUpdateTechnicalSession`, payload);
};

const deleteTechnicalSession = async (id) => {
    return $axios.post(`/memo/deleteTechnicalSession?id=${id}`);
};

export {
    getInstitutionByInstCode,
    getAllInstitutions,
    getAllInstitutionsMemos,
    addOrUpdateInstitution,
    deleteInstitution,
    getInstitutionById,
    getInstitutionTypeById,
    getInstitutionTypes,
    addOrUpdateInstitutionType,
    deleteInstitutionType,
    getAllRegulatoryDirectives,
    addOrUpdateRegulatoryDirective,
    deleteRegulatoryDirective,
    getAllSanctions,
    addOrUpdateSanction,
    deleteSanction,
    getAllTechnicalSessions,
    addOrUpdateTechnicalSession,
    deleteTechnicalSession,
    getAllWarnings,
    addOrUpdateWarning,
    deleteWarning,
    getAllMemos,
    getAllRegulatoryDirectivesDT,
    getAllTechnicalSessionsDT,
    getAllSanctionsDT,
    getAllWarningsDT,
};
